import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * HCL Zoom SVG
 *
 * @returns
 */
function HclZoomSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 24 24"
			className={classnames('hcl-enlarge-icon', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<path d="M15.5 14h-0.79l-0.28-0.27c0.98-1.14 1.57-2.62 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5c0 3.59 2.91 6.5 6.5 6.5 1.61 0 3.090-0.59 4.23-1.57l0.27 0.28v0.79l5 4.99 1.49-1.49-4.99-5zM9.5 14c-2.49 0-4.5-2.010-4.5-4.5s2.010-4.5 4.5-4.5c2.49 0 4.5 2.010 4.5 4.5s-2.010 4.5-4.5 4.5z"></path>
			<path d="M12 10h-2v2h-1v-2h-2v-1h2v-2h1v2h2z"></path>
		</svg>
	);
}

export default HclZoomSVG;
